import _ from 'lodash'
import constants from 'scoreboard/components/constants'
const { SPACED_EMDASH } = constants
import i18n from 'scoreboard/components/i18n'
import formatValue from 'scoreboard/components/format-value'
import DashboardData from 'scoreboard/dashboards/dashboard-data'
import DataType from 'scoreboard/datasets/model/data-type'
const { PERCENT } = DataType

/**
 * Sets appropriate series.title and series.subtitle for pie charts
 */
function applyPieLabels (chart, series, seriesPoints, data) {
	let labels = []

	if (chart.pieLabelName) {
		// note: previous code has already built this title (could be scorecard node, could be dataset,
		// could be custom, etc), so just reuse it
		labels.push(series.title)
	}

	if (chart.pieLabelOrganization) {
		let domainObject = DashboardData[series.section](data, series.domainObjectId)
		if (domainObject) {
			let org = DashboardData.organizations(data, domainObject.organizationId)
			if (org) {
				labels.push(org.label)
			}
		}
	}

	if (chart.pieLabelSeries) {
		labels.push(i18n.get(series.dataField))
	}

	if (chart.pieLabelValue || chart.pieLabelPercentage) {
		var point = series.points[0]

		if (point && !_.isNil(point.raw)) {
			let pct
			if (chart.pieLabelPercentage) {
				var total = _.sumBy(seriesPoints, function (points) {
					var point = points[0]

					var raw = point && point.raw
					return !_.isNumber(point) ? raw : 0
				})

				pct = formatValue({
					value: point.raw / total,
					dataType: PERCENT
				})
			}

			let value
			if (chart.pieLabelValue) {
				value = point.formatted || series.formatter(point.raw)
			}

			// If both percentage and value are turned on, subtitle will be:
			//   [slice's percentage] (emdash) [value or score]
			//   Examples: "75.5% — $700 USD" or "75.5% — 700.5"
			let label = ''
			if (!_.isNil(pct)) {
				label += pct

				if (!_.isNil(value)) {
					label += SPACED_EMDASH
				}
			}

			if (!_.isNil(value)) {
				label += value
			}

			if (label.length > 0) {
				labels.push(label)
			}
		}
	}

	if (labels.length > 0) {
		series.title = labels[0]
	} else{
		delete series.title
	}

	if (labels.length > 1) {
		series.subtitle = labels.slice(1)
	}
}

/**
 * #36980 for charts v4, this formats the subtitle text for a pie slice and places
 * the result in the serie.point.formatted property. Note this is based off a
 * section of the `applyPieLabels` method above, but can't really be abstracted
 * because the new charts library uses a different structure and flag names
 *
 * @param serie the serie to apply formatting to
 * @param total the total value among all pie slices
 * @param labelSettings the label settings for this chart
 */
function applyPieSliceSubtitle(serie, total, labelSettings = {}) {
	if (labelSettings.chartedValues || labelSettings.percentages) {
		serie.points.forEach(point => {
			if (point && !_.isNil(point.raw)) {
				let pct
				if (labelSettings.percentages) {
					pct = formatValue({
						value: point.raw / total,
						dataType: PERCENT
					})
				}

				let value
				if (labelSettings.chartedValues) {
					value = point.formatted || serie.formatter(point.raw)
				}

				let label = ''
				if (!_.isNil(pct)) {
					label += pct

					if (!_.isNil(value)) {
						label += SPACED_EMDASH
					}
				}

				if (!_.isNil(value)) {
					label += value
				}
				point.formatted = label
			}
		})
	}
}

export default applyPieLabels
export { applyPieSliceSubtitle }
applyPieLabels.__filename__ = 'charts/chart-data/apply-pie-labels.js'
